<template>
  <div>
    <div
      class="overlaytopbar"
      v-if="isOpen"
      @click="isOpen = $refs.menuIcon.checked = false"
    ></div>
    <header class="element-to-hide login-profile-topbar-A01">
      <button class="toggle-btn" @click="$emit('toggle-sidebar')">
        <img
          src="../assets/topbar/sidebar-open.svg"
          height="30px"
          alt="sidebar-open"
          loading="lazy"
        />
      </button>
      <div class="topbar" @keyup.enter="handleSelect">
        <multiselect
          ref="routeSelect"
          v-model="selectedItem"
          :options="filteredOptions"
          :searchable="true"
          :internal-search="true"
          :custom-label="customLabel"
          :show-no-results="false"
          :show-no-options="false"
          :show-labels="false"
          :allow-empty="false"
          placeholder="Type to search..."
          label="label"
          track-by="value"
          @search-change="onSearchChange"
          @select="handleSelect"
        >
          <template #option="{ option }">
            <div class="option-item">
              <img
                v-if="option.type === 'doctor' && option.image"
                :src="option.image ? option.image : 'defaultImage'"
                class="avatar"
                alt="Doctor"
              />
              <span
                >{{ option.type === "doctor" ? "👨‍⚕️" : "📁" }}
                {{ option.label }}</span
              >
            </div>
          </template>
          <!-- 👇 Show before typing -->
          <template #beforeList>
            <div
              v-if="!searchQuery || filteredOptions.length === 0"
              class="multiselect__message"
            >
              🔍 Type to search routes or doctors
            </div>
          </template>
        </multiselect>
      </div>
      <input
        type="checkbox"
        id="mobile-icon"
        @change="isOpen = $event.target.checked"
        ref="menuIcon"
      />
      <label for="mobile-icon" class="toggle"
        ><span class="hamburger-icon"></span
      ></label>
      <nav>
        <ul class="nav-items">
          <li>
            <router-link to="/">
              <img
                src="@/assets/topbar/home.svg"
                alt="home"
                loading="lazy"
                width="24px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-7" style="width: 100%"
                >Home<span class="arrow">&#x25bc;</span></label
              >
            </router-link>
            <input id="submenu-7" type="checkbox" />
            <ul class="submenu-7">
              <li>
                <router-link to="/" class="goto-page-link">Home</router-link>
              </li>
            </ul>
          </li>

          <li >
            <a href="#">
              <img
                src="@/assets/topbar/stethoscope.svg"
                alt="home"
                loading="lazy"
                width="24px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-1" style="width: 100%"
                >Who I Am<span class="arrow">&#x25bc;</span></label
              >
            </a>
            <input id="submenu-1" type="checkbox" />
            <ul class="submenu-1">
              <li><a href="#" class="disabledSection">Who I Am</a></li>
              
              <li v-if="this.$store.getters.hasuserdetails.role == 'doctor' || 
          this.$store.getters.hasuserdetails.role == 'student' || this.$store.getters.hasuserdetails.role == 'paramedics'">
  <router-link to="/doctor-calender-setup">My Planner | Calender</router-link>
</li>
              <li><router-link to="/Affiliate_Associate">Become Affiliate | Associate</router-link></li>
               <li><router-link to="/my-appointment-daybook">My Daybook | Appointments</router-link></li>
             
              <li v-if="this.$store.getters.hasuserdetails.role == 'doctor' || this.$store.getters.hasuserdetails.role == 'student' || this.$store.getters.hasuserdetails.role == 'paramedics' ">
                <router-link to="/Coming_Soon">My Meeting</router-link></li>
              <li v-if="this.$store.getters.hasuserdetails.role == 'customer'"><router-link to="/blogs">All Blog</router-link></li>
            </ul>
          </li>
          <li v-if="this.$store.getters.hasuserdetails.role == 'doctor' || this.$store.getters.hasuserdetails.role == 'student' || this.$store.getters.hasuserdetails.role == 'paramedics'">
            <a href="#">
              <img
                src="@/assets/topbar/team.svg"
                alt="home"
                loading="lazy"
                width="26px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-4" style="width: 100%">
                Involvements<span class="arrow">&#x25bc;</span></label
              >
            </a>
            <input id="submenu-4" type="checkbox" />
            <ul class="submenu-4">
              <li><a href="#" class="disabledSection">Involvements</a></li>
              <li><router-link to="/my_team_view">My Team</router-link></li>
             
              
              <li><router-link to="/savedandAppliedJobs">My Job Board</router-link></li>
              
              <li><router-link to="/my_group_view">My Groups</router-link></li>
              <li><router-link to="/my-blogs">My Blog</router-link></li>
              
              <li v-if="this.$store.getters.hasuserdetails.role == 'doctor' "><router-link to="/teacherscourses">My Lectures/Tutorial</router-link></li>
            </ul>
          </li>
          <li>
            <router-link
              to="/notificationspage"
              class="notification-link"
              style="position: relative"
            >
              <span
                class="count hide-mobile"
                id="unreadNotificationBadge"
                style="position: absolute; right: 18px"
                >{{ unreadNotificationCount }}</span
              >
              <div class="notification-icon-container">
                <img
                  src="../assets/topbar/notification.svg"
                  alt="notification"
                  loading="lazy"
                  height="24px"
                />
                <span class="arrow hide-mobile">&#x25bc;</span>
                <!-- Unread Notification Badge -->
              </div>
              <label for="submenu-3" style="width: 100%">
                Notifications
                <span class="arrow">&#x25bc;</span>
              </label>
              <!-- <span class="arrow">&#x25bc;</span> -->
            </router-link>

            <ul class="submenu-3">
              <li>
                <router-link to="/notificationspage" class="goto-page-link"
                  >Notification</router-link
                >
              </li>
            </ul>
          </li>

          <li>
            <a href="#">
              <img
                src="@/assets/topbar/office_bag.svg"
                alt="home"
                loading="lazy"
                width="25px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-6" style="width: 100%"
                >Portfolio<span class="arrow">&#x25bc;</span></label
              >
            </a>
            <input id="submenu-6" type="checkbox" />
            <ul class="submenu-6">
              <li><a href="#" class="disabledSection">Portfolio</a></li>

              <li><router-link to="/coinsDashboard">My Coins</router-link></li>
              
              <li><router-link to="/my-credits">My Credits</router-link></li>
              <li>
                <router-link to="/Doctor-Profile-Details"
                  >My Resume</router-link
                >
              </li>
              <li>
                <router-link to="/subscribers">My Subscriptions</router-link>
              </li>
              <li>
                <router-link to="/FamilyManagement">My Family</router-link>
              </li>
            </ul>
          </li>
          <li v-if="this.$store.getters.hasuserdetails.role == 'doctor' ">
            <router-link to="/Coming_Soon">
              <img
                src="@/assets/topbar/docs.svg"
                alt="docs"
                loading="lazy"
                width="24px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="submenu-7" style="width: 100%"
                >Events<span class="arrow">&#x25bc;</span></label
              >
            </router-link>
            <input id="submenu-7" type="checkbox" />
            <ul class="submenu-7">
              <li >
                <router-link to="/Coming_Soon" class="goto-page-link">Events</router-link>
              </li>
            </ul>
          </li>

         <li v-if="$store.getters.hasuserdetails.role == 'doctor'">
  <router-link to="/Coming_Soon" >
    <img
      src="@/assets/topbar/message.svg"
      alt="mail"
      loading="lazy"
      width="24px"
    />
    <span class="arrow hide-mobile">&#x25bc;</span>

    <label for="submenu-8" style="width: 100%">
      Mail<span class="arrow">&#x25bc;</span>
    </label>
  </router-link>

  <!-- checkbox for dropdown -->
  <input id="submenu-8" type="checkbox" />

  <!-- submenu -->
  <ul class="submenu-8">
    <li>
      <router-link to="/Coming_Soon" class="goto-page-link">
        Mail
      </router-link>
    </li>
  </ul>
</li>
          <!-- <li v-if="this.$store.getters.hasuserdetails.role == 'doctor'">
            <a class="hide-mobile" href="#">

              <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12M21 12C21 7.02944 16.9706 3 12 3M21 12H19M3 12C3 7.02944 7.02944 3 12 3M3 12H5M12 3V5M13.3229 10.5C12.9703 10.1888 12.5072 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 11.4027 13.7381 10.8665 13.3229 10.5ZM13.3229 10.5L15.8229 8"
                    stroke="#000000" stroke-width="2" stroke-linecap="round" />
                </g>
              </svg>

             
            </a>
          </li> -->
          <li v-if="$store.getters.hasuserdetails.role == 'doctor'">
  <router-link to="/AddCart">
    <span class="count hide-mobile">{{ cartItemCount }}</span>
    <img
      src="@/assets/topbar/shopping.svg"
      alt="shopping"
      loading="lazy"
      width="24px"
    />
    <span class="arrow hide-mobile">&#x25bc;</span>

    <label for="submenu-9" style="width: 100%">
      Cart<span class="arrow">&#x25bc;</span>
    </label>
  </router-link>

  <!-- checkbox -->
  <input id="submenu-9" type="checkbox" />

  <!-- submenu -->
  <ul class="submenu-9">
    <li>
      <router-link to="/AddCart" class="goto-page-link">
        Cart
      </router-link>
    </li>
  </ul>
</li>

          <li>
            <a v-on:click="toggleVisibility">
              <img
                src="@/assets/topbar/setting.svg"
                alt="setting"
                loading="lazy"
                width="24px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label for="" style="width: 100%"> Settings</label>
            </a>
          </li>
          <li @click="logout" >
            <router-link to="/"
            v-tippy="{ content: 'Logout' }">
              <img
                src="@/assets/topbar/logout.svg"
                alt="logout"
                loading="lazy"
                width="20px"
              />
              <span class="arrow hide-mobile">&#x25bc;</span>
              <label @click="logout" for="submenu" style="width: 100%">
                Logout</label
              >
            </router-link>
          </li>
        </ul>
      </nav>
    </header>
    <div v-show="isVisible" class="setting-box">
      <div class="TopbarSetting" style="position: fixed" ref="TopbarSetting">
        <p class="pageSettingHeading">⚙ Settings</p>
        <div class="layout"></div>
        <hr class="PagrHR" />
        <p class="layoutHeading" style="margin-left: 15px">Region & Language</p>
        <div class="layout">
          <div class="select">
            <LanguageSelector
              :allLanguageData="NewLangData"
              @update:language="updateLanguage"
            />
          </div>
        </div>
        <hr class="PagrHR" />

        <div class="layoutBackground">
          <p style="font-size: 12px; margin-left: 13px; margin-top: 9px">
            Edit Mode
          </p>
          <button class="editBackgroundBtn" @click="togglePopup">
            Toggle Visibility
          </button>
          <!-- <button class="editBackgroundBtn" @click="togglePopup">Toggle Visibility</button> -->
        </div>
        <hr class="PagrHR" />
        <div class="layoutBackground">
          <p style="font-size: 12px; margin-left: 13px; margin-top: 9px">
            Custom Theme
          </p>
          <input
            style="margin: 4px; margin-left: 13px; width: 83%"
            type="color"
            @change="changeColor($event.target.value)"
            class="color-picker"
          />
        </div>
        <hr class="PagrHR" />
        <p
          style="
            font-weight: 500;
            font-size: 14px;
            margin: top 10px;
            margin-left: 11px;
          "
        >
          Theme
        </p>
        <div class="ThemeSelection">
          <div
            @click="
              changeColor(
                'linear-gradient(90deg, rgb(255, 255, 255) 50%, rgb(44, 54, 63) 50%)',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                90deg,
                rgb(255, 255, 255) 50%,
                rgb(44, 54, 63) 50%
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(114, 130, 251), rgb(114, 130, 251), rgb(121, 52, 247))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(114, 130, 251),
                rgb(114, 130, 251),
                rgb(121, 52, 247)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(243, 176, 73), rgb(234, 125, 86), rgb(212, 32, 125))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(243, 176, 73),
                rgb(234, 125, 86),
                rgb(212, 32, 125)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(160, 185, 82), rgb(79, 164, 109), rgb(0, 160, 160))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(160, 185, 82),
                rgb(79, 164, 109),
                rgb(0, 160, 160)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(38, 176, 177), rgb(19, 115, 170), rgb(0, 52, 163))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(38, 176, 177),
                rgb(19, 115, 170),
                rgb(0, 52, 163)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(141, 125, 162), rgb(89, 73, 110), rgb(32, 15, 53))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(141, 125, 162),
                rgb(89, 73, 110),
                rgb(32, 15, 53)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(28, 62, 92), rgb(28, 62, 92), rgb(28, 62, 92))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(28, 62, 92),
                rgb(28, 62, 92),
                rgb(28, 62, 92)
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'radial-gradient(circle at 10% 20%, rgb(97, 186, 255) 0%, rgb(166, 239, 253) 90.1%)',
              )
            "
            class="theme"
            style="
              background-image: radial-gradient(
                circle at 10% 20%,
                rgb(97, 186, 255) 0%,
                rgb(166, 239, 253) 90.1%
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                ' linear-gradient(65.9deg, rgb(85, 228, 224) 5.5%, rgba(75, 68, 224, 0.74) 54.2%, rgb(64, 198, 238) 55.2%, rgb(177, 36, 224) 98.4%)',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                65.9deg,
                rgb(85, 228, 224) 5.5%,
                rgba(75, 68, 224, 0.74) 54.2%,
                rgb(64, 198, 238) 55.2%,
                rgb(177, 36, 224) 98.4%
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                ' linear-gradient( 67.6deg,  rgba(225,242,254,1) -2.8%, rgba(193,224,250,1) 44.6%, rgba(19,116,197,1) 102.4% )',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                67.6deg,
                rgba(225, 242, 254, 1) -2.8%,
                rgba(193, 224, 250, 1) 44.6%,
                rgba(19, 116, 197, 1) 102.4%
              );
            "
          ></div>
          <div
            @click="
              changeColor(
                'linear-gradient(45deg, rgb(92, 96, 112), rgb(92, 96, 112), rgb(55, 58, 67))',
              )
            "
            class="theme"
            style="
              background-image: linear-gradient(
                45deg,
                rgb(92, 96, 112),
                rgb(92, 96, 112),
                rgb(55, 58, 67)
              );
            "
          ></div>
        </div>
        
      </div>
    </div>
    <div class="searchSuggestion element-to-hide">
      <div
        class="suggestionDoctors"
        style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px"
      >
        <div v-if="isVisible1" ref="outerDiv">
          <div id="buttons">
            <button class="crossDiv" @click="isVisible1 = false">X</button>
          </div>
          <div style="padding-left: 10px; overflow-y: scroll" id="products">
            <div
              class="singleItemDiv"
              v-for="(doctor, index) in filteredDoctors"
              :key="index"
            >
              <img
                src="src\assets\doctorData\rahulKumar.jpeg"
                alt="Product Image"
                style="max-width: 50%; height: 30%"
              />
              <h3>{{ doctor.name }}</h3>
              <a
                class="doctorView"
                href="#"
                @click="this.$router.push(`View_profile/${doctorPage}`)"
                @mouseover="showProfile"
                @mouseout="hideProfile"
              >
                View Profile
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//action mapper from vue
import { useToast } from "vue-toastification";
import presenceSocket from "@/services/presenceSocket";
const toast = useToast();
import { useStore, mapActions, mapGetters } from "vuex";
import multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import dummyData from "./dummyData.js";
import LanguageSelector from "./LanguageSelector.vue";
import emitter from "@/eventBus";
import axios from "axios";

export default {
  components: {
    multiselect,
    LanguageSelector,
  },

  props: {
    msg: String,
    currentURL: String,
    resetpass: Boolean,
    languages: Array,
    language: String,
    NewLangData: Array,
  },
  setup() {
    const store = useStore();

    const toggleVisibilityEdit = () => {
      store.commit("toggleVisibility"); // Assuming 'toggleVisibility' is a mutation in your Vuex store
    };
    // Example usage in a method
    const someMethod = () => {
      toggleVisibilityEdit(); // Call toggleVisibilityEdit in a method
    };

    return {
      toggleVisibilityEdit,
      someMethod,
    };
  },
  // use to show or hide edit mode
  data() {
    return {
      colorChangeTimeout: null,
      SHOWSIDEBAR: false,
      editModeProfiles: false,
      medicines: dummyData.medicines,
      showDiv: false,
      isVisible: false,
      isVisible1: false,
      searchName: "",
      selectedDiv: null,
      isNavMenuVisible: false,
      showLabel: true,
      cartItemCount: 0,
      currentIndex: 0,
      names: [],
      selectedCategory: "all",
      doctors: [],
      path: [],
      selectedValues: [],
      routesList: [],
      searchList: {},
      doctorPage: "",
      isOpen: false,

      // suraj's coding
      selectedItem: null,
      searchQuery: "",
      routeOptions: [],
      doctorOptions: [],
      defaultImage: require("@/assets/profile/img/userProfile.jpg"),
    };
  },
  mounted() {
    window.addEventListener("keydown", (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        this.$refs.routeSelect.$el.querySelector("input").focus();
      }
    });
    window.addEventListener("resize", this.handleResize);
    // Initial check for screen width
    this.handleResize();
    this.fetchCartCount();
    this.getData();
    this.getDataDoctor();
    this.fetchData();
    this.getResumeData();
    // Load saved theme on component mount
    this.loadSavedTheme();
    // this.getResumeDoctor(); // fn throwing err
    // this.getTransactionCodes(); // this one too
    this.fetchCartCount();
    this.fetchUnreadNotificationCount();
    emitter.on("cart-updated", this.fetchCartCount);
  },
  created() {
    this.fetchRoutes();
    this.fetchDoctors();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutSide);
    // ✅ still correct in Vue 3 Options API
    emitter.off("cart-updated", this.fetchCartCount);
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery || this.searchQuery.length < 1) {
        return []; // hide dropdown by default
      }

      const query = this.searchQuery.toLowerCase();

      return [...this.routeOptions, ...this.doctorOptions].filter((opt) =>
        opt.label.toLowerCase().includes(query),
      );
    },
    ...mapGetters(["unreadNotificationCount"]),

    routes() {
      return this.$store.state.routes;
    },
  },

  name: "Topbar_page",
  isVisible1: false,

  methods: {
    ...mapActions(["updateUnreadNotificationCount"]),
    handleClickOutSide(event) {
      const modal = this.$refs.TopbarSetting;
      if (modal && !modal.contains(event.target)) {
        this.isVisible = false;
      }
    },
    async fetchUnreadNotificationCount() {
      try {
        const user = this.$store.getters.hasuserdetails;

        if (!user?._id) {
          console.log("User not logged in, setting notification count to 0");
          this.updateUnreadNotificationCount(0);
          return;
        }

        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}notification/totalnotification`,
          { params: { userId: user._id } },
        );

        const unRead = response?.data?.data?.unRead || 0;
        this.updateUnreadNotificationCount(unRead);
        localStorage.setItem("unreadNotification", unRead);
      } catch (error) {
        console.error("Fetch Unread Notification Count Error:", {
          message: error.message,
          response: error.response?.data,
        });
      }
    },
    async fetchCartCount() {
      try {
        const user = this.$store.getters.hasuserdetails;

        if (!user?._id) {
          console.log("User not logged in, setting cart count to 0");
          this.cartItemCount = 0;
          return;
        }

        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}addTocart/get-cart-count`,
          { params: { userId: user._id } },
        );

        if (response.data.success) {
          this.cartItemCount = response.data.count;
        } else {
          console.error("API Error:", response.data.message);
          this.cartItemCount = 0;
        }
      } catch (error) {
        console.error("Fetch Cart Count Error:", {
          message: error.message,
          response: error.response?.data,
        });
        this.cartItemCount = 0;
      }
    },
    // Listen to event for live updates
    refreshCartCount() {
      this.fetchCartCount();
    },
    // Load saved theme from localStorage and apply it
    loadSavedTheme() {
      // Only load theme if user is logged in
      if (
        this.$store.getters.hasuserdetails &&
        this.$store.getters.hasuserdetails._id
      ) {
        const savedColor = localStorage.getItem("userThemeColor");
        if (savedColor) {
          this.applyThemeColor(savedColor);
        }

        // Then fetch from server to ensure we have the latest
        this.fetchProductDetails();
      } else {
        // Clear theme if no user is logged in (shouldn't happen, but just in case)
        localStorage.removeItem("userThemeColor");
      }
    },

    // Apply theme color to elements
    applyThemeColor(color) {
      if (!color) return;

      const adminContainers =
        document.getElementsByClassName("adminPageContainer");
      const timelineDates = document.getElementsByClassName(
        "timeline__event__date",
      );

      if (adminContainers.length > 0) {
        adminContainers[0].style.background = color;
      }
      if (timelineDates.length > 0) {
        timelineDates[0].style.background = color;
      }
    },

    onSearchChange(query) {
      this.searchQuery = query;
    },
    fetchRoutes() {
      try {
        const routes = this.$router?.options?.routes || [];
        console.log("✅ Routes:", routes);

        this.routeOptions = routes
          .filter((route) => route.name && route.path)
          .map((route) => ({
            label: route.name.replace(/_/g, "-").toLowerCase(),
            value: route.path,
            type: "route",
          }));
      } catch (error) {
        console.log("Routes error", error);
      }
    },

    async fetchDoctors() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/referralAllData`,
          { withCredentials: true },
        );

        this.doctorOptions = res.data.doctors.map((doc) => ({
          label: [
            doc.selectedTitle,
            doc.firstName,
            doc.middleName,
            doc.lastName,
          ]
            .filter(Boolean)
            .join(" "),
          value: doc._id,
          type: "doctor",
          image: doc.imageUrl || null,
        }));

        console.log("✅ Doctors:", this.doctorOptions);
      } catch (err) {
        console.error("❌ Doctor Fetch Error:", err);
      }
    },

    customLabel(option) {
      return option.label;
    },
    handleSelect() {
      if (!this.selectedItem) return;

      const { type, value } = this.selectedItem;

      if (type === "route") {
        this.$router.push(value);
      } else if (type === "doctor") {
        this.$router.push(`/Show-Doctors-Profile/${value}`);
      }
      this.selectedItem = null;
      this.searchQuery = "";
    },

    ...mapActions(["toggleDiv"]),
    togglePopup() {
      this.toggleDiv();
      console.log("Button clicked, action dispatched."); // Log button click
    },
    // togglePopup() {
    //   document.getElementsByClassName('editSvgIcon')
    // },
    redirectToAssociates() {
      // Replace the URL with the actual path to your associate registration form
      this.$router.push("/associate-registration");
    },
    ...mapActions(["getAllResumes", "toggleDiv"]),
    updateLanguage(newLanguage) {
      console.log(newLanguage);
      this.$emit("update:language", newLanguage);
    },

    handleOptionSelect(selectedOption) {
      // console.log("Option clicked:", selectedOption);
      switch (selectedOption.type) {
        case "route":
          this.$router.push(`/${selectedOption.path}`);
          break;
        case "transactionCode":
          this.$router.push(`/${selectedOption.object_component_name}`);
          break;
        // case "vendor":
        case "resume":
          this.$router.push({
            name: "view-Doctor",
            params: { userId: selectedOption.user_id },
          });

          this.$store.dispatch("fetchSpecificResume", selectedOption.user_id);
          break;
        case "vendor":
          this.$router.push(`/checkout/${selectedOption.mid}`);
          break;
        default:
          break;
      }
    },

    async fetchData() {
      try {
        let response = await this.fetchRoutes();
        this.routesList = response;
        for (let route of this.routesList) {
          route.type = "route";
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    },

    async getResumeData() {
      try {
        await this.getAllResumes();
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    },

    async logout() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/logout`,
          {
            withCredentials: true,
          },
        );
        if (response.data.success) {
          // Clear theme from localStorage on logout
          localStorage.removeItem("userThemeColor");
           presenceSocket.disconnect();
          this.$store.dispatch("logout");
          await this.$router.push({ path: "/" });
          toast.clear();
          toast.success(response.data.message);
        }
      } catch (error) {
        console.error("Logout failed:", error);
        toast.success(
          error.response.data.message || error.message || "Failed to logout..",
        );
      }
    },
    async getData() {
      try {
        const response = await fetch(
          process.env.VUE_APP_BASE_URL + "resume/get-resumes",
        );
        if (!response.ok) {
          throw new Error("Failed to retrive resumes");
        }
        const data = await response.json();
        // console.log("data from fetch", data);

        this.doctors = data.map((resume) => ({
          _id: resume._id,
          name: resume.name,
        }));
        // console.log("drs", this.doctors);
      } catch (error) {
        console.error("Error : ", error.message);
      }
    },
    async getDataDoctor() {
      try {
        const response = await fetch(
          process.env.VUE_APP_BASE_URL + "resume/get-resumesDoctor",
        );
        if (!response.ok) {
          throw new Error("Failed to retrive resumes");
        }
        const data = await response.json();
        // console.log("data from fetch", data);

        this.doctors = data.map((resume) => ({
          _id: resume._id,
          name: resume.name,
        }));
        // console.log("drs", this.doctors);
      } catch (error) {
        console.error("Error : ", error.message);
      }
    },
    handleResize() {
      // Update the showLabel property based on the screen width
      this.showLabel = window.innerWidth <= 1000;
    },
    beforeDestroy() {
      // Remove the resize event listener when the component is destroyed
      window.removeEventListener("resize", this.handleResize);
    },
  toggleVisibility(event) {
  event.stopPropagation();
  this.isVisible = !this.isVisible;
},

    toggleNavMenu() {
      const navMenus = document.querySelectorAll(".nav-menu");
      navMenus.forEach((navMenu) => {
        navMenu.style.transition = "ease-out 0.1s";
      });
      this.isNavMenuVisible = !this.isNavMenuVisible;
    },

    changeColor(_this) {
      // Clear previous timeout
      if (this.colorChangeTimeout) {
        clearTimeout(this.colorChangeTimeout);
      }

      // Only allow theme change if user is logged in
      if (
        !this.$store.getters.hasuserdetails ||
        !this.$store.getters.hasuserdetails._id
      ) {
        toast.error("Please login to change theme");
        return;
      }

      // Apply color immediately for preview (but don't save to server yet)
      this.applyThemeColor(_this);

      // Debounce the API call - wait 1 second after user stops changing
      this.colorChangeTimeout = setTimeout(() => {
        const formData = new FormData();
        formData.append("color_code", _this);
        formData.append("user_id", this.$store.getters.hasuserdetails._id);

        axios
          .post(
            process.env.VUE_APP_BASE_URL +
              "profile-customization/change_bgcolor",
            formData,
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            },
          )
          .then((response) => {
            // Store color in localStorage for persistence
            localStorage.setItem("userThemeColor", _this);
            toast.success("Theme Has Been Changed Successfully.");
          })
          .catch((error) => {
            console.error(error);
            toast.error("Failed to save theme.");
          });
      }, 1000); // Wait 1 second after user stops changing
    },

    fetchProductDetails() {
      // Only fetch if user is logged in
      if (
        !this.$store.getters.hasuserdetails ||
        !this.$store.getters.hasuserdetails._id
      ) {
        return;
      }

      axios
        .post(
          `${process.env.VUE_APP_BASE_URL}profile-customization/get_doctorDatabyid`,
          {
            id: this.$store.getters.hasuserdetails._id,
          },
        )
        .then((response) => {
          let data = response.data.Data;
          if (data && data.color_code) {
            // Save to localStorage
            localStorage.setItem("userThemeColor", data.color_code);
            // Apply the color
            this.applyThemeColor(data.color_code);
          }
        })
        .catch((error) => {
          console.error("Error fetching product details", error);
        });
    },

    togglesidebar() {
      let asideDoc = document.getElementsByClassName("aside")[0];
      if (asideDoc.style.display === "block") {
        document.getElementsByClassName("aside")[0].style.display = "none";
        document.getElementsByClassName(
          "parent-conatiner",
        )[0].style.gridTemplateColumns = "100%";
        this.SHOWSIDEBAR = false;
      } else {
        document.getElementsByClassName("aside")[0].style.display = "block";
        document.getElementsByClassName(
          "parent-conatiner",
        )[0].style.gridTemplateColumns = "60px 1fr";
        this.SHOWSIDEBAR = true;
      }
    },

    toggleDivVisibility() {
      this.isVisible = !this.isVisible;
    },

    toggleDivVisibility1() {
      this.isVisible1 = !this.isVisible1;
    },
    showProfile() {
      this.isProfileVisible = true;
    },
    //  navigateToDetails(_id) {
    //    this.$router.push({ name: "view-Doctor", params: { id: _id } });
    //  },
    filterProduct(category) {
      this.selectedCategory = category;
    },
    search() {
      // Handle search logic here if needed
      this.products.forEach((product) => {
        product.isHidden = !product.name
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
    },
    showDoctors() {
      this.showDiv = !this.showDiv;
      document.getElementById("doctorTypes").style.display = "grid";
      document.getElementById("doctorTypes").style.gap = "9px";
      document.getElementById("doctorTypes").style.gridTemplateColumns =
        "1fr 1fr 1fr";
      document.getElementById("doctorTypes").style.fontSize = "12px";
      document.getElementById("doctorTypes").style.marginTop = "9px";
      document.getElementById("doctorTypes").style.marginLeft = "7%";
    },
  },
  watch: {
  isVisible(newVal) {
    if (newVal) {
      document.addEventListener("click", this.handleClickOutSide);
    } else {
      document.removeEventListener("click", this.handleClickOutSide);
    }
  }
}
};
</script>
<style scoped>
/*-------- topbar css start here ---------*/
:deep .multiselect__tags {
  font-size: 10px !important;
  border: 1px solid #6b0a2375 !important;
}

.vue-multiselect .multiselect__input {
  width: 90px;
  height: 20px;
}

.multiselect {
  width: 450px !important;
  height: 20px !important;
  margin-left: 10px;
}

.suggestionDoctors #buttons .button-value {
  border: 1px solid #6b0a23;
  border-radius: 15px;
  padding: 5px 20px;
  outline: none;
  background-color: #fff;
}

.suggestionDoctors #buttons {
  display: grid;
  grid-template-columns: 1fr;
  place-items: end;
  padding: 10px;
}

.suggestionDoctors {
  background-color: #fff;
}

/* page setting css  */
/* topbar Setting Theme Section  */
.singleItemDiv {
  display: grid;
  grid-template-columns: 0% 60% 30%;
  background-color: #fff;
  height: 40px;
  border-top: 1px solid lightgrey;
  place-content: space-between;
}

.singleItemDiv h3 {
  position: relative;
  left: -23px;
}

.singleItemDiv a {
  position: relative;
  top: 7px;
  text-decoration: none;
  color: #6ba6b9;
  text-align: right;
  margin-right: 10px;
}

.singleItemDiv img {
  border-radius: 50%;
  padding: 10px;
}

.singleItemDiv:hover {
  background-color: aquamarine;
}

.searchSuggestion {
  position: fixed;
  top: 46px;
  width: 60%;
  left: 70px;
  z-index: 999;
}

.layout {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
}



.overlaytopbar {
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.432);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 9;
  display: none;
}

.layoutBackground {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}









.crossDiv {
  float: right;
  border: none;
  background-color: rgb(255, 147, 147);
  padding: 10px;
  color: rgb(255, 255, 255);
  position: relative;
}



* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.login-profile-topbar-A01 {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  position: fixed;
  width: 100%;
  z-index: 999;
  border-bottom: 1px solid grey;
  height: 53px;
}

.logo {
  cursor: pointer;
  padding: 0 1rem;
  border-radius: 50%;
}

.toggle {
  cursor: pointer;
  padding: 25px 10px;
  position: relative;
}

nav {
  flex: 1 1 100%;
}

nav ul {
  list-style: none;
}

#mobile-icon,
[id^="submenu"] {
  display: none;
}

nav a,
nav label {
  font-weight: 500;
  font-size: 12px;
  color: black;
  background: #fff;
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: 0px 5px;
  height: 45px;
  transition: background 0.4s ease-out;
}

nav a:hover,
nav label:hover {
  background: lightblue;
}

.arrow {
  margin-left: 9px;
  margin-top: 4px;
  color: #eee;
  font-size: 10px;
}



/*------- mobile nav --------*/

@media (max-width: 918px) {
  .overlaytopbar {
    display: block;
  }

  nav ul {
    max-height: 0;
    overflow: scroll;
    transition: max-height 0.3s ease-out;
  }

  #mobile-icon:checked ~ nav > ul {
    max-height: 80vh;
  }

  [id^="submenu"]:checked ~ [class^="submenu"] {
    max-height: 100vh;
    overflow: visible;
  }

  .hamburger-icon {
    width: 18px;
    height: 3px;
    background-color: #6b0a23;
    display: block;
    position: relative;
  }

  .hamburger-icon:before,
  .hamburger-icon:after {
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: #6b0a23;
    transition: all 0.2s;
  }

  .hamburger-icon:before {
    top: 5px;
  }

  .hamburger-icon:after {
    top: -5px;
  }

  #mobile-icon:checked ~ .toggle {
    border-radius: 50em;
    transition: all 0.2s ease-out;
  }

  .nav-items li {
    display: flex;
    flex-direction: column;
  }



  .hide-mobile {
    display: none;
  }
}

/*-------desktop nav --------*/
@media (min-width: 919px) {
  .login-profile-topbar-A01 {
    flex-wrap: nowrap;
  }

  nav,
  .logo {
    flex: none;
    margin-right: 70px;
  }

  .toggle,
  nav label {
    display: none;
  }

  nav ul {
    display: flex;
  }

  nav li {
    position: relative;
  }

  nav ul ul {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
  }

  li:hover > ul {
    max-height: 100vh;
    overflow: visible;
  }

  [class^="submenu"] {
    flex-direction: column;
    position: absolute;
  }

  .submenu-1,
  .submenu-2,
  .submenu-4,
  .submenu-5,
  .submenu-6,
  .submenu-7,
  .submenu-8,
  .submenu-9,
  .submenu-3 {
    width: 140px;
    left: 0;
  }

  .submenu-2 {
    top: 0px;
    left: 100%;
    width: 120px;
  }
}

.submenu-1,
.submenu-2,
.submenu-4,
.submenu-5,
.submenu-6,
.submenu-7,
.submenu-8,
.submenu-9,
.submenu-3 a {
  font-size: 12px;
}

.nav-items li a svg {
  height: 19px;
  width: 19px;
}

/* .submenu-1,
  .submenu-2,
  .submenu-4,
  .submenu-5,
  .submenu-6,
  .submenu-7,
  .submenu-8,
  .submenu-9 {
    background-color: lightgray;
    border-left: 1px solid grey;
    border-right: 1px solid grey;
    border-bottom: 1px solid grey;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
   */

.submenu-1,
.submenu-2,
.submenu-4,
.submenu-5,
.submenu-6,
.submenu-7,
.submenu-8,
.submenu-9 {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}


.disabledSection {
  background-color: #ba0b23;
  color: #fff;
  pointer-events: none;
}
.goto-page-link{
    background-color: #ba0b23;
  color: #fff;
}
.goto-page-link:hover{
    background-color: #ba0b23;
  color: #fff;
}
.count {
  position: absolute;
  top: 7px;
  right: 17px;
  background: #fa4040;
  color: white;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 20px;
}

@media only screen and (max-width: 800px) {
  .suggestionDoctors #buttons .button-value {
    border: none;
    border-radius: 15px;
    padding: 5px 20px;
    outline: none;
    background-color: rgb(170, 168, 168);
    width: 70px;
  }

  .suggestionDoctors #buttons {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    place-items: center;
    padding: 10px;
    overflow-x: scroll;
  }

  .suggestionDoctors {
    background-color: #fff;
  }

  /* page setting css  */
  /* topbar Setting Theme Section  */
  .singleItemDiv {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background-color: #fff;
    height: 48px;
  }

  .singleItemDiv img {
    display: none;
  }

  .singleItemDiv:hover {
    background-color: aquamarine;
  }

  .searchSuggestion {
    position: fixed;
    top: 46px;
    width: 100%;
    z-index: 999;
    left: 0px;
  }

  .singleItemDiv h3 {
    position: relative;
    left: -8px;
  }

  .singleItemDiv a {
    position: relative;
    right: -90px;
    top: 7px;
    text-decoration: none;
    color: #6ba6b9;
  }

  .crossDiv {
    float: right;
    border: none;
    background-color: rgb(255, 147, 147);
    padding: 10px;
    color: rgb(255, 255, 255);
    position: relative;
    right: -325px;
  }
}

.toggle-btn {
  background: none;
  display: none;
  border: none;
  color: black;
  font-size: 24px;
  cursor: pointer;
  margin-right: 16px;
}

@media screen and (max-width: 768px) {
  .toggle-btn {
    display: block;
  }
}

@media only screen and (max-width: 600px) {
  .multiselect {
    width: 50vw !important;
    height: 16px !important;
    padding: 4px !important;
    margin-bottom: 10px;
  }

  .multiselect__content-wrapper {
    width: 100% !important;
    width: auto;
  }
}

.multiselect__tags {
  min-height: 40px;
  display: block;
  padding: 8px 5px 0 8px !important;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 13px;
}

.multiselect__message {
  padding: 10px;
  font-size: 0.9rem;
  color: #888;
  text-align: center;
}

.option-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}

@media only screen and (max-width: 500px) {
  .multiselect {
    width: 65vw !important;
    height: 16px !important;
    padding: 4px !important;
  }

  .multiselect__content-wrapper {
    width: 100% !important;
    width: auto;
  }
}


/* ===== Setting Box Container ===== */
/* ===== Soft Background ===== */
.setting-box {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: flex-end;
  padding: 70px 25px 25px;
  z-index: 9999;
}

/* ===== Clean Floating Card ===== */
.TopbarSetting {
  width: 320px;
  max-height: 85vh;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  animation: fadeSlide 0.2s ease;
}

/* ===== Typography ===== */
.pageSettingHeading {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 14px;
}

.layoutHeading {
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 6px;
}

/* ===== Button ===== */
.editBackgroundBtn {
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #f7f7f7;
  font-size: 13px;
  cursor: pointer;
  transition: 0.2s ease;
}

.editBackgroundBtn:hover {
  background: #ececec;
}

/* ===== Theme Grid ===== */
.ThemeSelection {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(34px, 1fr));
  gap: 8px;
  margin-top: 8px;
}

/* ===== Theme Color Boxes ===== */
.theme {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid #eee;
  transition: 0.2s ease;
}

.theme:hover {
  transform: scale(1.08);
  border-color: #ccc;
}

/* ===== Divider ===== */
.PagrHR {
  margin: 12px 0;
  opacity: 0.2;
}

/* ===== Animation ===== */
@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*----- topbar css end here -----*/
</style>